import { render, staticRenderFns } from "./KlasusSearch.vue?vue&type=template&id=f086a96c&scoped=true"
import script from "./KlasusSearch.vue?vue&type=script&lang=js"
export * from "./KlasusSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f086a96c",
  null
  
)

export default component.exports